import DashboardResultHeader from "./DashboardResultHeader";

export default DashboardResultHeader;